import { BenefitsActivatedCard } from '@components/Common/BenefitsActivatedCard';

export const UserAlreadyAMember = () => <BenefitsActivatedCard variant='alreadyLinked' />;
